// @flow
import DrawingContainer from './containers/DrawingContainer';

export default DrawingContainer;